import { defineStore } from 'pinia'
import { ref, computed } from 'vue'
import config from '@/config'
import { login, register, getUserInfo } from '@/api/auth'
import bgmManager from '@/utils/bgm'
import { disconnectSocket } from '@/utils/socket.js'

export const useUserStore = defineStore('user', () => {
  // 状态
  const accessToken = ref(localStorage.getItem(config.storage.token) || '')  // AccessToken（短期）
  const refreshToken = ref(localStorage.getItem('refresh_token') || '')  // RefreshToken（长期）
  const userInfo = ref(JSON.parse(localStorage.getItem(config.storage.userInfo) || 'null'))
  
  // 向后兼容：token字段代理到accessToken
  const token = computed({
    get: () => accessToken.value,
    set: (value) => { accessToken.value = value }
  })
  
  // 计算属性
  const isLoggedIn = computed(() => !!accessToken.value)
  
  // 设置AccessToken
  function setAccessToken(newAccessToken) {
    accessToken.value = newAccessToken
    localStorage.setItem(config.storage.token, newAccessToken)
  }
  
  // 登录
  async function loginAction(username, password) {
    try {
      const res = await login(username, password)
      if (res.code === 200 && res.data) {
        // 新的响应格式：accessToken + refreshToken
        accessToken.value = res.data.accessToken
        refreshToken.value = res.data.refreshToken
        userInfo.value = res.data.user
        
        localStorage.setItem(config.storage.token, res.data.accessToken)
        localStorage.setItem('refresh_token', res.data.refreshToken)
        localStorage.setItem(config.storage.userInfo, JSON.stringify(res.data.user))
        
        return { success: true }
      } else {
        return { success: false, message: res.message || '登录失败' }
      }
    } catch (error) {
      console.error('登录失败:', error)
      return { success: false, message: error.message || '登录失败' }
    }
  }
  
  // 注册
  async function registerAction(data) {
    try {
      const res = await register(data)
      if (res.code === 200 && res.data) {
        // 注册成功后自动登录
        accessToken.value = res.data.accessToken
        refreshToken.value = res.data.refreshToken
        userInfo.value = res.data.user
        
        localStorage.setItem(config.storage.token, res.data.accessToken)
        localStorage.setItem('refresh_token', res.data.refreshToken)
        localStorage.setItem(config.storage.userInfo, JSON.stringify(res.data.user))
        
        return { success: true, message: res.message || '注册成功' }
      } else {
        return { success: false, message: res.message || '注册失败' }
      }
    } catch (error) {
      console.error('注册失败:', error)
      return { success: false, message: error.message || '注册失败' }
    }
  }
  
  // 获取用户信息
  async function fetchUserInfo() {
    try {
      const res = await getUserInfo()
      if (res.code === 200) {
        userInfo.value = res.data
        localStorage.setItem(config.storage.userInfo, JSON.stringify(res.data))
      }
    } catch (error) {
      console.error('获取用户信息失败:', error)
    }
  }
  
  // 退出登录
  function logout() {
    // 暂停BGM播放
    bgmManager.pause()
    
    // 断开WebSocket连接
    disconnectSocket()
    
    accessToken.value = ''
    refreshToken.value = ''
    userInfo.value = null
    localStorage.removeItem(config.storage.token)
    localStorage.removeItem('refresh_token')
    localStorage.removeItem(config.storage.userInfo)
  }
  
  return {
    accessToken,
    refreshToken,
    token,  // 向后兼容
    userInfo,
    isLoggedIn,
    setAccessToken,
    loginAction,
    registerAction,
    fetchUserInfo,
    logout
  }
})

